module.exports = __webpack_public_path__ + "static/media/black-stripe.d75bf31b.svg";